import * as React from 'react';
import { CategoriesContainer } from './components/Categories';
import { RegionsContainer } from './components/Regions';
import { ValidityPeriodContainer } from './components/ValidityPeriod';
import * as styles from './Header.css';

export const Header = () => {
  return (
    <div className={styles['header']}>
      <RegionsContainer />

      <CategoriesContainer />

      <ValidityPeriodContainer />
    </div>
  );
};
